import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { ConfirmDialog } from "primereact/confirmdialog";
import { useNavigate, useParams } from "react-router-dom";
import { useLanguage } from "context/LanguageContext";
import { useNotification } from "context/NotificationContext";
import {
  renderYesNoField,
  renderCheckboxGroup,
  convertYesNoFieldsToString,
  handleConfirmSave,
  handleNavigateBack,
  validateFields
} from "components/formUtils";

const HemotransfusaoForm = () => {
  const { GetTranslation } = useLanguage();
  const notify = useNotification();
  const navigate = useNavigate();
  const { id } = useParams();

  const [formData, setFormData] = useState({
    transfusao_hemoderivados: "",
    momento_transfusao: [],
    elemento_transfundido: [],
  });

  const token = localStorage.getItem("token");

  useEffect(() => {
    if (id) {
      fetch(`${process.env.REACT_APP_API_URL}/hemotransfusao/${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            const yesNoFields = ["transfusao_hemoderivados"];
            const convertedData = convertYesNoFieldsToString(data.data, yesNoFields);
            setFormData(convertedData);
          } else {
            notify({
              type: "error",
              message: data.error || "Erro ao buscar os dados",
            });
          }
        })
        .catch(() => {
          notify({
            type: "error",
            message: "Erro ao buscar os dados",
          });
        });
    }
  }, [id, token, notify]);

  const requiredFields = [];

  const apiUrl = id
    ? `${process.env.REACT_APP_API_URL}/hemotransfusao/update/${id}`
    : `${process.env.REACT_APP_API_URL}/hemotransfusao/add`;

  const handleSubmit = () => {
    const method = id ? "PUT" : "POST";
    fetch(apiUrl, {
      method: method,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        if (response.ok) {
          notify({
            type: "success",
            message: id ? "Hemotransfusão atualizada com sucesso!" : "Hemotransfusão adicionada com sucesso!",
          });
          
        } else {
          response.json().then((data) => {
            notify({
              type: "error",
              message: `Erro: ${data.error}`,
            });
          });
        }
      })
      .catch(() => {
        notify({
          type: "error",
          message: "Erro ao enviar os dados",
        });
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Função para lidar com checkbox
  const handleCheckboxChange = (e, field) => {
    const { value, checked } = e.target;
    setFormData((prev) => {
      const updatedValues = checked
        ? [...prev[field], value] // Adiciona se estiver checado
        : prev[field].filter((v) => v !== value); // Remove se desmarcado
      return { ...prev, [field]: updatedValues };
    });
  };

  const confirmSave = handleConfirmSave(formData, requiredFields, validateFields, GetTranslation, notify, handleSubmit);
  const handleBack = handleNavigateBack(navigate, id);

  return (
    <div className="card p-3">
      <ConfirmDialog />
      <h4>{id ? GetTranslation("Edit_Hemotransfusao") : GetTranslation("Add_Hemotransfusao")}</h4>
      <form className="row g-3">
        {/* Transfusão de Hemoderivados */}
        {renderYesNoField(
          formData,
          handleChange,
          "transfusao_hemoderivados",
          "Transfusão de hemoderivados",
          GetTranslation
        )}

        {/* Momento da Transfusão */}
        {renderCheckboxGroup(
          formData,
          handleCheckboxChange,
          "momento_transfusao",
          "Momento da transfusão",
          ["Intra-operatório", "Pós-operatório"],
          GetTranslation
        )}

        {/* Elemento Transfundido */}
        {renderCheckboxGroup(
          formData,
          handleCheckboxChange,
          "elemento_transfundido",
          "Elemento transfundido",
          ["Hemácias", "Plaquetas", "Plasma Fresco Congelado", "Crioprecipitado", "Fibrinogênio", "Complexo protrombínico"],
          GetTranslation
        )}

        <div className="col-12 d-flex justify-content-between">
          <Button label={GetTranslation("Voltar")} className="btn btn-secondary" onClick={handleBack} />
          <Button label={id ? GetTranslation("Update") : GetTranslation("Create")} className="btn btn-primary" type="submit" onClick={confirmSave} />
        </div>
      </form>
    </div>
  );
};

export default HemotransfusaoForm;